export default "__VITE_ASSET__rLp8nWI8__"